/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type { PriceFeedV2, PriceFeedV2Interface } from "../PriceFeedV2";

const _abi = [
  {
    type: "function",
    name: "accesses",
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "addOracle",
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_primaryOracle",
        type: "address",
      },
      {
        internalType: "address",
        name: "_secondaryOracle",
        type: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "changeVerificator",
    inputs: [
      {
        internalType: "address",
        name: "_verificator",
        type: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "fetchPrice",
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "getExternalPrice",
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "lastGoodPrice",
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "oracles",
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    outputs: [
      {
        internalType: "address",
        name: "primaryWrapper",
        type: "address",
      },
      {
        internalType: "address",
        name: "secondaryWrapper",
        type: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "removeOracle",
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "renounceOwnership",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setAccessTo",
    inputs: [
      {
        internalType: "address",
        name: "_addr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_hasAccess",
        type: "bool",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setUp",
    inputs: [
      {
        internalType: "address",
        name: "_verificator",
        type: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "verificator",
    inputs: [],
    outputs: [
      {
        internalType: "contract IOracleVerificationV1",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "event",
    name: "AccessChanged",
    inputs: [
      {
        name: "_token",
        type: "address",
        indexed: true,
      },
      {
        name: "_hasAccess",
        type: "bool",
        indexed: false,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "OracleAdded",
    inputs: [
      {
        name: "_token",
        type: "address",
        indexed: true,
      },
      {
        name: "_primaryWrappedOracle",
        type: "address",
        indexed: false,
      },
      {
        name: "_secondaryWrappedOracle",
        type: "address",
        indexed: false,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "OracleRemoved",
    inputs: [
      {
        name: "_token",
        type: "address",
        indexed: true,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "OracleVerificationChanged",
    inputs: [
      {
        name: "_newVerificator",
        type: "address",
        indexed: true,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: true,
      },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "TokenPriceUpdated",
    inputs: [
      {
        name: "_token",
        type: "address",
        indexed: true,
      },
      {
        name: "_price",
        type: "uint256",
        indexed: false,
      },
    ],
    anonymous: false,
  },
] as const;

export class PriceFeedV2__factory {
  static readonly abi = _abi;
  static createInterface(): PriceFeedV2Interface {
    return new utils.Interface(_abi) as PriceFeedV2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PriceFeedV2 {
    return new Contract(address, _abi, signerOrProvider) as PriceFeedV2;
  }
}
